import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as FSaver from 'file-saver';
import * as XLSX from 'xlsx';

import SaveStatus from '../../UIComponents/SaveStatus';

import mapStateToProps from './mapStateToProps';

const BigExcelSaver = () =>{
    const { geoMultiObjReportExcel } = useSelector(mapStateToProps);
    useEffect(()=>{
        if(geoMultiObjReportExcel && geoMultiObjReportExcel.data && !geoMultiObjReportExcel.loading){
            const { data } = geoMultiObjReportExcel
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = 'xlsx';
            const fileName='Report';
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.aoa_to_sheet(data);
            XLSX.utils.book_append_sheet(workbook, worksheet, "Отчет", true);
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const sData = new Blob([excelBuffer], {type: fileType});
            FSaver.saveAs(sData, `${fileName}_${(new Date()).toDateString()}.${fileExtension}`);
        }
    },[geoMultiObjReportExcel])
    return <SaveStatus title="Загрузка отчета Excel" dataObj={geoMultiObjReportExcel} errShowTime={1000} successShowTime={100}/>
}
export default BigExcelSaver